import { Badge } from 'lucide-react';
import React from 'react';

export interface StatsCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  badge?: {
    content: React.ReactNode;
    color: 'success' | 'error' | 'warning' | 'info';
  };
  className?: string;
  onClick?: () => void;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon,
  badge,
  className = '',
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`flex-1 min-w-[200px] rounded-2xl bg-white p-5 md:p-6 cursor-pointer transition-transform duration-200 hover:scale-[1.02] shadow-sm hover:shadow-md active:scale-[0.98] ${className}`}
    >
      <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl">
        {icon}
      </div>

      <div className="flex items-end justify-between mt-5">
        <div>
          <span className="text-sm text-gray-500">{title}</span>
          <h4 className="mt-2 font-bold text-gray-800 text-title-sm">{value}</h4>
        </div>

        {badge && <Badge color={badge.color}>{badge.content}</Badge>}
      </div>
    </div>
  );
};

export default StatsCard;
